const styles = theme => ({
  root: {
    height: '100vh',
    minHeight: 0,
    overflow: 'hidden',
    background: '#f4f6f9',
    color: '#213047',
  },
  formWrapper: {
    height: '100%',
    minHeight: 0,
    overflow: 'hidden',
    width: '100%',
  },
  signupPage: {
    boxSizing: 'border-box',
    height: '100%',
    margin: '0 !important',
    minHeight: 0,
    width: '100% !important',
  },
  brandPanel: {
    backgroundColor: '#143b7b',
    color: '#ffffff',
    display: 'flex',
    height: '100%',
    minHeight: 0,
  },
  brandContent: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    padding: '48px 11% 42px',
    width: '100%',
  },
  logo: {
    height: 'auto',
    maxWidth: 170,
    width: '100%',
  },
  brandTitle: {
    color: '#ffffff',
    fontSize: '2.15rem',
    fontWeight: 500,
    lineHeight: 1.18,
    marginTop: 76,
  },
  brandCopy: {
    color: 'rgba(255, 255, 255, 0.78)',
    fontSize: '1rem',
    lineHeight: 1.65,
    marginTop: 18,
    maxWidth: 390,
  },
  sidebarSteps: {
    marginTop: 'auto',
    paddingTop: 48,
  },
  sidebarStep: {
    alignItems: 'center',
    display: 'flex',
    marginTop: 20,
  },
  stepNumber: {
    alignItems: 'center',
    background: 'rgba(255, 255, 255, 0.16)',
    border: '1px solid rgba(255, 255, 255, 0.36)',
    borderRadius: '50%',
    color: 'rgba(255, 255, 255, 0.78)',
    display: 'inline-flex',
    flex: '0 0 28px',
    fontSize: '0.8rem',
    height: 28,
    justifyContent: 'center',
    marginRight: 13,
    width: 28,
  },
  stepNumberCurrent: {
    background: '#f5a623',
    borderColor: '#f5a623',
    color: '#173b79',
    fontWeight: 700,
  },
  stepNumberComplete: {
    background: '#ffffff',
    borderColor: '#ffffff',
    color: '#143b7b',
  },
  sidebarStepTitle: {
    color: '#ffffff',
    fontSize: '0.96rem',
    fontWeight: 500,
  },
  sidebarStepDescription: {
    color: 'rgba(255, 255, 255, 0.62)',
    fontSize: '0.78rem',
    marginTop: 2,
  },
  contentPanel: {
    background: '#ffffff',
    height: '100%',
    minHeight: 0,
    overflow: 'hidden',
  },
  wizardContent: {
    boxSizing: 'border-box',
    height: '100%',
    margin: '0 auto',
    maxWidth: 850,
    minHeight: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: '46px 11% 34px',
    width: '100%',
  },
  pageHeading: {
    borderBottom: '1px solid #e2e7ee',
    paddingBottom: 24,
  },
  stepCaption: {
    color: '#6a7890',
    fontSize: '0.76rem',
    fontWeight: 600,
    letterSpacing: '0.7px',
    textTransform: 'uppercase',
  },
  headline: {
    color: '#163d7c',
    fontSize: '2rem',
    fontWeight: 500,
    lineHeight: 1.2,
    marginTop: 8,
  },
  subheading: {
    color: '#65748a',
    fontSize: '0.98rem',
    lineHeight: 1.5,
    marginTop: 8,
  },
  signInPrompt: {
    color: '#65748a',
    fontSize: '0.9rem',
    marginTop: 16,
  },
  orangeLink: {
    color: '#d88700',
    fontWeight: 500,
    textDecoration: 'none',
  },
  stepContent: {
    padding: '20px 0 22px',
  },
  textField: {
    width: '100%',
  },
  formControl: {
    width: '100%',
  },
  countryGroupHeader: {
    background: '#f4f7fb',
    borderBottom: '1px solid #dce4ee',
    borderTop: '1px solid #dce4ee',
    color: '#1c408c',
    fontSize: '0.72rem',
    fontWeight: 700,
    letterSpacing: '0.45px',
    lineHeight: '30px',
    textTransform: 'uppercase',
  },
  stepNote: {
    background: '#f4f7fb',
    borderLeft: '3px solid #8ba6cf',
    color: '#53657d',
    fontSize: '0.88rem',
    lineHeight: 1.5,
    padding: '12px 14px',
  },
  sectionDivider: {
    borderTop: '1px solid #e2e7ee',
    marginTop: 8,
    paddingTop: '25px !important',
  },
  sectionTitle: {
    color: '#183f7d',
    fontSize: '1.05rem',
    fontWeight: 500,
  },
  sectionDescription: {
    color: '#68778c',
    fontSize: '0.86rem',
    marginTop: 4,
  },
  questionGroup: {
    marginBottom: 18,
  },
  questionLabel: {
    color: '#213047',
    display: 'block',
    fontSize: '0.9rem',
    fontWeight: 500,
    lineHeight: 1.5,
    marginBottom: 6,
  },
  required: {
    color: theme.palette.error.main,
  },
  checkboxList: {
    border: '1px solid #dbe2eb',
    display: 'grid',
    gridGap: '9px 15px',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    padding: '12px 14px',
  },
  checkboxControl: {
    marginLeft: 0,
    marginRight: 0,
    minHeight: 38,
    '& span:last-child': {
      color: '#405169',
      fontSize: '0.82rem',
      lineHeight: 1.25,
    },
  },
  actionRow: {
    alignItems: 'center',
    borderTop: '1px solid #e2e7ee',
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 18,
    '& button': {
      alignItems: 'center',
      display: 'inline-flex',
      gap: 7,
      minWidth: 126,
    },
  },
  backButton: {
    color: '#46607d',
  },
  reviewGrid: {
    display: 'grid',
    gridGap: 14,
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
  reviewSection: {
    border: '1px solid #dce4ee',
    fontSize: '0.88rem',
    lineHeight: 1.55,
    minHeight: 120,
    padding: '16px 18px',
    '& p': {
      color: '#4d5d71',
      overflowWrap: 'anywhere',
    },
  },
  reviewHeading: {
    color: '#153c7a !important',
    fontSize: '0.83rem !important',
    fontWeight: '600 !important',
    letterSpacing: '0.45px',
    marginBottom: 7,
    textTransform: 'uppercase',
  },
  termsRow: {
    alignItems: 'center',
    display: 'flex',
    marginTop: 24,
    '& p': {
      color: '#4a5a70',
      fontSize: '0.9rem',
    },
  },
  termsControl: {
    marginLeft: 0,
    marginRight: 0,
  },
  termsLink: {
    background: 'none',
    border: 0,
    color: '#1c408c',
    cursor: 'pointer',
    font: 'inherit',
    padding: 0,
    textDecoration: 'underline',
  },
  previewNotice: {
    background: '#fff8e7',
    border: '1px solid #f1d493',
    color: '#765411',
    fontSize: '0.86rem',
    lineHeight: 1.5,
    marginTop: 17,
    padding: '12px 14px',
  },
  verificationStep: {
    maxWidth: 620,
  },
  verificationCopy: {
    color: '#52647b',
    fontSize: '0.94rem',
    lineHeight: 1.55,
    marginBottom: 18,
  },
  verificationContacts: {
    borderBottom: '1px solid #e0e6ef',
    borderTop: '1px solid #e0e6ef',
    display: 'grid',
    gridGap: 18,
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    padding: '14px 0',
  },
  verificationLabel: {
    color: '#6c7a8e',
    fontSize: '0.76rem',
    fontWeight: 600,
    letterSpacing: '0.45px',
    textTransform: 'uppercase',
  },
  verificationValue: {
    color: '#24364e',
    fontSize: '0.93rem',
    marginTop: 4,
    overflowWrap: 'anywhere',
  },
  verificationAction: {
    alignItems: 'center',
    background: '#f4f7fb',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 18,
    padding: '14px 16px',
    '& button': {
      flex: '0 0 auto',
      marginLeft: 18,
    },
  },
  verificationActionTitle: {
    color: '#1c408c',
    fontSize: '0.92rem',
    fontWeight: 500,
  },
  verificationActionDescription: {
    color: '#5e6e83',
    fontSize: '0.82rem',
    lineHeight: 1.4,
    marginTop: 3,
  },
  codeSentNotice: {
    background: '#edf8f2',
    borderLeft: '3px solid #3d936c',
    color: '#276647',
    fontSize: '0.84rem',
    marginTop: 14,
    padding: '10px 12px',
  },
  codeInput: {
    marginTop: 14,
    maxWidth: 310,
  },
  successState: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 130px)',
    textAlign: 'center',
  },
  successIcon: {
    color: '#27845f',
  },
  successTitle: {
    color: '#153c7a',
    fontSize: '1.85rem',
    fontWeight: 500,
    marginTop: 22,
  },
  successCopy: {
    color: '#647389',
    lineHeight: 1.6,
    marginTop: 13,
    maxWidth: 510,
  },
  successActions: {
    alignItems: 'center',
    display: 'flex',
    gap: 20,
    marginTop: 26,
  },
  returnLink: {
    color: '#1c408c',
    fontSize: '0.9rem',
    fontWeight: 500,
    textDecoration: 'none',
  },
  mobileProgress: {
    display: 'none',
  },
  '@media (max-width: 960px)': {
    formWrapper: {
      overflowY: 'auto',
    },
    signupPage: {
      height: 'auto',
      minHeight: '100%',
    },
    brandPanel: {
      height: 'auto',
      minHeight: 0,
    },
    brandContent: {
      padding: '30px 7% 28px',
    },
    brandTitle: {
      fontSize: '1.55rem',
      marginTop: 34,
    },
    sidebarSteps: {
      display: 'none',
    },
    contentPanel: {
      height: 'auto',
      minHeight: 0,
      overflow: 'visible',
    },
    wizardContent: {
      height: 'auto',
      minHeight: 0,
      overflow: 'visible',
      padding: '42px 8% 40px',
    },
  },
  '@media (max-width: 600px)': {
    brandPanel: {
      display: 'none',
    },
    wizardContent: {
      padding: '28px 24px 34px',
    },
    mobileProgress: {
      display: 'flex',
      gap: 7,
      marginBottom: 22,
    },
    mobileProgressDot: {
      background: '#d8dee8',
      borderRadius: 5,
      height: 4,
      width: 34,
    },
    mobileProgressDotActive: {
      background: '#1c408c',
    },
    headline: {
      fontSize: '1.7rem',
    },
    checkboxList: {
      gridTemplateColumns: '1fr',
    },
    verificationContacts: {
      gridTemplateColumns: '1fr',
    },
    verificationAction: {
      alignItems: 'flex-start',
      flexDirection: 'column',
      '& button': {
        marginLeft: 0,
        marginTop: 12,
      },
    },
    reviewGrid: {
      gridTemplateColumns: '1fr',
    },
    actionRow: {
      '& button': {
        minWidth: 112,
      },
    },
  },
})

export default styles
